export const SAFEA_VERSIONS = Object.freeze({
  V3        : 'v3',
  MIGRATING : 'migrating',
  V2        : 'v2'
});

export const RESPONSE_TYPES = Object.freeze({
  CODE          : 'code',
  REFRESH_TOKEN : 'refresh_token'
});

export const SAFEA_VERSION = process.env.SAFEA_VERSION || SAFEA_VERSIONS.V2;
export const SAFEA_V3_ENABLED = SAFEA_VERSION === SAFEA_VERSIONS.V3 || SAFEA_VERSION === SAFEA_VERSIONS.MIGRATING;

// OAuth2 settings
export const CODE_CHALLENGE_METHOD = 'S256';

// Routes
export const HOME_PATH = '/';
export const CONTEXT_SELECTION_PATH = '/welcome';
export const NO_CONTEXT_PATH = '/role-not-found';
export const CALLBACK_PATH = '/callback';
// Do not use this directly. Use the isIgnoredRedirectPath function instead.
export const IGNORED_REDIRECT_PATHS = [CONTEXT_SELECTION_PATH, NO_CONTEXT_PATH, CALLBACK_PATH];

export const DISABLED_OAUTH2_ROUTES = [
  /^\/redirect\/[\w-]+$/
];

// v3 endpoints
export const TOKEN_REFRESH_ERRORS = ['invalid_grant'];
export const PROVIDER = {
  CLAIM_NAMESPACE    : 'https://grupoa.education/safea/spec/user/claim',
  IDP_ERROR_PAGE     : `${process.env.SAFEA_IDP_URL}/auth/error/`,
  AUTHORIZE_ENDPOINT : `${process.env.SAFEA_API_V3}/oauth2/authorize`,
  TOKEN_ENDPOINT     : `${process.env.SAFEA_API_V3}/oauth2/token`,
  SIGNOUT_ENDPOINT   : `${process.env.SAFEA_API_V3}/oauth2/oidc/logout`
};
